import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { EventDto } from '../../../../models/event/event';
import { EventService } from '../../../../services/events/event.service';

export class SchoolScheduleDatabase {
    /** Stream that emits whenever the data has been modified. */
    dataChange: BehaviorSubject<EventDto[]> = new BehaviorSubject<EventDto[]>([]);

    get data(): EventDto[] {
        return this.dataChange.value;
    }

    constructor(
        private eventService: EventService
    ) {
        setTimeout(() => {
            this.eventService.getAll().subscribe(response => {
                for (const r of response) {
                    this.add(r);
                }
                // datos.sort((a, b) => {
                //     if (a.StartDate.getTime() < b.StartDate.getTime()) {
                //         return -1;
                //     }
                //     if (a.StartDate.getTime() > b.StartDate.getTime()) {
                //         return 1;
                //     }
                //     // a debe ser igual b
                //     return 0;
                // });
                // datos.forEach(e => {
                //     this.add(e);
                // });
            }, error => {

            });
        }, 100);
    }

    public add(store: EventDto) {
        const copiedData = this.data.slice();
        copiedData.push(store);
        this.dataChange.next(copiedData);
    }

    public edit(store: EventDto) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData[index] = store;
        this.dataChange.next(copiedData);
    }

    public delete(store: EventDto) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData.splice(index, 1);
        this.dataChange.next(copiedData);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/events/school-schedule/school-schedule-database.ts